webpackJsonp([2],{

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decoder__ = __webpack_require__(4);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__decoder__["a" /* default */]);

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    Vue.prototype.$jwtDec = this;
    Vue.jwtDec = this;
  },
  decode: function decode(jwt) {
    if (typeof jwt !== 'string' & !jwt instanceof String) return null;

    var splitted = jwt.split('.');
    if (splitted.length < 2) return null;

    var obj1 = JSON.parse(atob(splitted[0]));
    var obj2 = JSON.parse(atob(splitted[1]));

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj1, obj2);
  }
});

/***/ })

},[17]);


// WEBPACK FOOTER //
// docs/js/vue-jwt-decode.86bc508e8cf5a4ea21a8.js